<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/xk06RO/tc-custom/9781780102375.jpg?1734326752354" alt="This image is the cover for the book Last Refuge, The Hannah Ives Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Last Refuge, The Hannah Ives Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b>Hannah can’t resist a leading role in a historical reality show, but she never expected murder to be the main theme. </b><br/>  <br/> Lights, camera, murder . . . It doesn’t take much arm-twisting to persuade Hannah Ives to join the twelve-strong cast of <i>Patriot House, 1774</i>, a reality show recreating eighteenth-century colonial life during the turbulent days leading up to the American Revolution. But when a member of the production crew is found murdered, it’s up to Hannah to change the course of history before hers is ended on live TV.<br/>  <br/> “Likable Hannah is a sympathetic character who holds the cast of Patriot House and this premise-driven tale together.” —<i>Booklist</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Marcia Talley
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Severn House
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2aec2539